/**
 * AureNovel 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * AureNovel 品牌特定主题配置
 */
export const theme = {
  // 引用装饰线颜色 (AureNovel 使用金/橙主色)
  quoteColor: 'rgba(245, 158, 11, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
